<template lang="pug">
  span.is-clickable(v-if="membership" @click.stop="openDetails" :class="{'tag membership-tag': isTag, 'has-text-hoverable': !isTag}") 
    span.icon(v-if="membership.type === 'package'")
      i.mdi.mdi-package-variant
    span.icon(v-else)
      i.mdi.mdi-card-account-details-outline
    span {{name}}
    span.ml-1(v-if="membership.type === 'membership'")
      span   |    
      span(v-if="membership.sale") {{membership.capacity ? membership.remainingVisits : '∞'}}     
      span(v-else) {{membership.capacity || '∞'}}
</template>
<script>
import MembershipDetails from './MembershipDetails'
import {mapActions, mapState} from 'vuex'
export default {
  props: {
    value: {type: String, required: true},
    isTag: {type: Boolean, default: true}
  },

  computed: {
    ...mapState('memberships', ['membershipsMap']),
    membership() {
      return this.membershipsMap[this.value]
    },
    name() {
      if (this.membership.name.length > 13) {
        return this.membership.name.substring(0, 13) + '...'
      }
      return this.membership.name
    }
  },
  async created() {
    await this.getMembershipById(this.value)
  },
  methods: {
    ...mapActions('memberships', ['getMembershipById']),
    openDetails() {
      this.$buefy.modal.open({
        parent: this,
        width: 640,
        props: {value: this.value},
        hasModalCard: true,
        fullScreen: this.isMobile(),
        component: MembershipDetails,
        canCancel: ['outside', 'escape'],
        events: {
          update: membership => {
            Object.assign(this.value, membership)
            this.$emit('update', membership)
          }
        }
      })
    }
  }
}
</script>
